var _g, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.795 6.404h-25.59c-0.883 0-1.599 0.716-1.599 1.599v15.994c0 0.884 0.716 1.599 1.599 1.599h25.59c0.883 0 1.599-0.715 1.599-1.599v-15.994c0-0.883-0.716-1.599-1.599-1.599zM2.672 10.669h26.656v2.133h-26.656v-2.133zM29.328 23.997c0 0.294-0.239 0.533-0.533 0.533h-25.59c-0.294 0-0.533-0.239-0.533-0.533v-10.129h26.656v10.129zM2.672 9.602v-1.599c0-0.294 0.239-0.533 0.533-0.533h25.59c0.294 0 0.533 0.239 0.533 0.533v1.599h-26.656z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.804 21.331h10.662v1.066h-10.662v-1.066z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.804 18.133h6.398v1.066h-6.397v-1.066z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.981 22.398h2.165c0.579 0 1.050-0.462 1.050-1.034v-0.064c0-0.571-0.47-1.035-1.050-1.035h-2.165c-0.58 0-1.051 0.463-1.051 1.035v0.064c0 0.572 0.47 1.034 1.051 1.034z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredit);
export default __webpack_public_path__ + "static/media/credit.f0f16e00d79ba31915e0067e18e25591.svg";
export { ForwardRef as ReactComponent };